import { lazyRetry } from '@/shared/core/lazyRetry';

export const VendorLogin = lazyRetry(() => import('./pages/VendorLogin'));
export const VendorDashboard = lazyRetry(() => import('./pages/VendorDashboard'));
export const VendorArrivals = lazyRetry(() => import('./pages/VendorArrivals'));
export const VendorDepartures = lazyRetry(() => import('./pages/VendorDepartures'));
export const VendorDailyRental = lazyRetry(() => import('./pages/VendorDailyRental'));
export const VendorTours = lazyRetry(() => import('./pages/VendorTours'));
export const VendorStays = lazyRetry(() => import('./pages/VendorStays'));
export const VendorInterpreters = lazyRetry(() => import('./pages/VendorInterpreters'));
export const VendorChanges = lazyRetry(() => import('./pages/VendorChanges'));
